export default __webpack_public_path__ + "static/media/header-bg.c217ba63.png";